var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu / Sidebar - Property"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.0625 20C7.5 20 7.01562 19.8043 6.60938 19.4128C6.20313 19.0213 6 18.5367 6 17.9591V7.2154C6 6.72764 6.14687 6.29122 6.44063 5.90614C6.73438 5.52106 7.11875 5.27718 7.59375 5.17449L13.2188 4.03851C13.6813 3.93582 14.0938 4.03851 14.4563 4.34657C14.8188 4.65463 15 5.05255 15 5.54031V14.7244C15 15.0967 14.8875 15.4272 14.6625 15.716C14.4375 16.0048 14.15 16.1813 13.8 16.2455L7.89375 17.4585C7.78125 17.4842 7.6875 17.5451 7.6125 17.6414C7.5375 17.7377 7.5 17.8436 7.5 17.9591C7.5 18.1003 7.55625 18.219 7.66875 18.3153C7.78125 18.4116 7.9125 18.4597 8.0625 18.4597H16.5V6.90734C16.5 6.68913 16.5719 6.50622 16.7156 6.3586C16.8594 6.21099 17.0375 6.13718 17.25 6.13718C17.4625 6.13718 17.6406 6.21099 17.7844 6.3586C17.9281 6.50622 18 6.68913 18 6.90734V18.4597C18 18.8833 17.8531 19.2459 17.5594 19.5475C17.2656 19.8492 16.9125 20 16.5 20H8.0625ZM9.15 15.6486C9.325 15.6101 9.46875 15.5203 9.58125 15.3791C9.69375 15.2379 9.75 15.0774 9.75 14.8977V7.25391C9.75 7.01003 9.65938 6.81107 9.47813 6.65704C9.29688 6.50301 9.0875 6.45166 8.85 6.50301C8.675 6.54152 8.53125 6.63137 8.41875 6.77256C8.30625 6.91376 8.25 7.07421 8.25 7.25391V14.8977C8.25 15.1416 8.34063 15.3406 8.52188 15.4946C8.70312 15.6486 8.9125 15.7 9.15 15.6486Z",
    fill: "#385CF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidebookIcon);
export default __webpack_public_path__ + "static/media/guidebook-icon.eb6d717a975deb28eae60bd0589c8747.svg";
export { ForwardRef as ReactComponent };